<div *ngFor="let alert of alerts" class="alert-animate {{ cssClass(alert) }} alert-dismissable">
  {{ alert.message }}
  <a class="close"
    role="button"
    tabindex="0"
    aria-label="Close notification"
     (click)="removeAlert(alert)"
     (keydown.enter)="removeAlert(alert)"
     (keydown.space)="removeAlert(alert)"
     title="Close">&times;</a>
</div>